import React from 'react';
import {
  useListProjectTriggersQuery, usePreloadCardsQuery,
} from '../../../../../generated/core-api/graphql-react-query';
import { getProjectTrigger, isProjectIntention } from '../../../../Components/MainWindow/Components/Pages/CommandPage/Hooks/useCommands';

export default function useContentMaps(projectId?: string | null) {
  const cards = usePreloadCardsQuery(
    { input: { id: projectId ?? '' } },
    { enabled: !!projectId, cacheTime: 30 * 60 * 1000 },
  );

  const commands = useListProjectTriggersQuery(
    { input: { id: projectId ?? '' }, infiniteInput: { projectId: projectId ?? '' } },
    { enabled: !!projectId, cacheTime: 30 * 60 * 1000 },
  );

  const cardTitleMap = React.useMemo(() => {
    const map = new Map<string, string>();
    cards.data?.getProject.scopes.items.forEach((scope) => {
      map.set(scope.cardId, scope.card.title);
    });
    return map;
  }, [cards.data]);

  const commandTitleMap = React.useMemo(() => {
    const map = new Map<string, string>();
    commands.data?.projectTrigger.list.items.forEach((command) => {
      const trigger = getProjectTrigger(command);
      if (trigger) {
        map.set(trigger.id, trigger.text);
      }
    });
    return map;
  }, [commands.data]);

  const isIntentionMap = React.useMemo(() => {
    const map = new Map<string, boolean>();
    commands.data?.projectTrigger.list.items.forEach((trigger) => {
      if (trigger) {
        map.set(trigger.triggerId, !!isProjectIntention(trigger));
      }
    });
    return map;
  }, [commands.data]);

  return { cardTitleMap, commandTitleMap, isIntentionMap };
}
